// extracted by mini-css-extract-plugin
export default {"select-border_animated":"CustomNewLine_select-border_animated__h9Nfq","appearAnim":"CustomNewLine_appearAnim__wz6Bc"};